module.exports = __webpack_public_path__ + "img/SketchPng0d94323b3ca7d25f9530825855b3d08f310593d582b0656bd730f29010ab1cdb.4f634b66.png";